export interface ScaleOptionLine {
    label?: string | null;
    description?: string | null;
}

export interface ScaleOptionWithDescription extends ScaleOptionLine {
    segments?: ScaleOptionLine[] | null;
}

/** Full wording saved with the answer, for example "Work - sedentary (secretarial, etc.)". */
export function scaleOptionAnswerText(option: ScaleOptionWithDescription): string {
    const lines = [{ label: option.label, description: option.description }, ...(option.segments ?? [])];
    return lines
        .map((line) => {
            const label = line.label?.trim() ?? "";
            const description = line.description?.trim() ?? "";
            if (label && description) return `${label} - ${description}`;
            return label || description;
        })
        .filter(Boolean)
        .join("; ");
}
